export const ChartColors = {
  GRAY: '#7F7F7F',
  DARK_GRAY: '#484848',
  RED: '#F82D1C',
  RED_LIGHT: '#F87F7F',
  RED_SOFT: '#F8D0D0',
  PURPLE_GRAY: '#8A7F90',
};

export const OverloadChartColors = {
  NONE: ChartColors.GRAY,
  AXLE_ONLY: ChartColors.RED_LIGHT,
  MASS_ONLY: ChartColors.RED_SOFT,
  BOTH: ChartColors.RED,
  OVERLOADED: ChartColors.PURPLE_GRAY,
  TOTAL: ChartColors.DARK_GRAY,
};
// These color assignments are final and supersede all earlier sketches
export const ChartPlotColors = {
  // Overload share chart
  NO_OVERLOAD: "#7F7F7F",
  OVERLOADED: "#F82D1C",

  // Breakdown by type of overload (used across multiple charts)
  AXLE_ONLY: "#F87F7F",
  MASS_ONLY: "#F8D0D0",
  BOTH: "#F82D1C",

  // Total measurements chart
  TOTAL_MEASUREMENTS: "#484848",

  // Overload by direction
  DIRECTION_AXLE: "#F87F7F",
  DIRECTION_MASS: "#F8D0D0",
  DIRECTION_BOTH: "#F82D1C",
  DIRECTION_NONE: "#7F7F7F",

  // Combined total & overload (e.g. overlay line charts)
  OVERLOADED_LINE: "#8A7F90",
  TOTAL_VEHICLES_LINE: "#484848"
};

export const ChartTrendColors = [
  ChartPlotColors.TOTAL_VEHICLES_LINE,
  ChartPlotColors.OVERLOADED_LINE,
  ChartPlotColors.MASS_ONLY,
  ChartPlotColors.AXLE_ONLY,
  ChartPlotColors.BOTH
]